import {create} from "zustand";

const useAiIssueCatchStore = create((set) => ({
  isOpen: false,
  setIsOpen: (isAiIssureCatchOpen: boolean) => set({ isAiIssureCatchOpen }),
  toggleIsOpen: () => set((state:{isOpen: boolean}) => ({ isOpen: !state.isOpen })),
}));

export {
  useAiIssueCatchStore,
}